import React, { Component } from 'react';
import Menu from './Menu';
import Sidebar from './Sidebar'
import Footer from './Footer'
import Content from './Content'
// import logo from '../logo.svg';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import './Main.css';
class Main extends Component {
  constructor(props) {
    super(props);            
    this.handleLogout = this.handleLogout.bind(this);    
    this.state = {
      isOpen: false
    };    
  }  
  handleLogout(e) {
    this.props.handleLogout(e);
  }  
  render() {    
    return (
      <MuiThemeProvider>
        <div>          
           <Menu handleLogout={this.handleLogout} />                    
          <div className="sidebar">                          
                <Sidebar/>                                      
          </div>          
          <Content/>                    
        </div>


      {/* <div className="container-fluid" style={containerStyle}>                         */}
        
        {/* <Menu handleLogout={this.handleLogout}/>         */}

        
        {/* <div className="row">
          <nav className="col-sm-3 col-md-2 hidden-xs-down bg-faded sidebar" style={sidebarStyle}>
            <Sidebar/>        
          </nav>
          <main className="col-sm-9 offset-sm-3 col-md-10 offset-md-2 pt-3" style={{backgroundColor:"red"}}>
            <Content/>
          </main>        
        </div> */}
        
        {/* <Footer/>         */}        
      
      {/* </div> */}
      </MuiThemeProvider>
    )
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/layout/Main.js